import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createDigest, deleteDigest, listFullTaskDigests, queryDigests, updateDigest, upsertDigest } from '@wix/ambassador-individual-scheduling-assistant-v1-digest/http';
import { bulkUpsertContacts, getKnowledge, isOrionAppInstalled, markTaskAsDone, pauseTask, sendSmsToUser, sendWhatsappToUser } from '@wix/ambassador-isa-digest-engine-v1-digest-engine/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { DigestClientBase } from './DigestClientBase';
export class DigestClient extends HttpBaseClient(DigestClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createDigestImpl", createDigest);
    _defineProperty(this, "queryDigestsImpl", queryDigests);
    _defineProperty(this, "updateDigestImpl", updateDigest);
    _defineProperty(this, "upsertDigestImpl", upsertDigest);
    _defineProperty(this, "deleteDigestImpl", deleteDigest);
    _defineProperty(this, "markTaskAsDoneImpl", markTaskAsDone);
    _defineProperty(this, "pauseTaskImpl", pauseTask);
    _defineProperty(this, "bulkUpsertContactsImpl", bulkUpsertContacts);
    _defineProperty(this, "listFullTaskDigestsImpl", listFullTaskDigests);
    _defineProperty(this, "getKnowledgeImpl", getKnowledge);
    _defineProperty(this, "isOrionAppInstalledImpl", isOrionAppInstalled);
    _defineProperty(this, "sendSmsToUserImpl", sendSmsToUser);
    _defineProperty(this, "sendWhatsappToUserImpl", sendWhatsappToUser);
  }
}
//# sourceMappingURL=DigestClientHttp.js.map